import * as React from 'react';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import { verticalAlign } from '../utils/customPropStyles';
import { imageError } from '../utils/imageError';
import { computed } from 'mobx';
import { DataStore } from '../stores';

const Image = styled<any, any>('img')`
    ${propStyles};
    ${verticalAlign};
    flex-shrink: 0;
`;

interface IconProps {
    theme?: any;
    dataStore?: DataStore;
    fileName: string;
}

@inject('dataStore')
@observer
class Icon extends React.Component<IconProps> {
    constructor(props) {
        super(props);
        this.handleImageError = this.handleImageError.bind(this);
    }

    handleImageError(e) {
        imageError(e.target);
    }

    @computed
    get iconSrc() {
        const { dataStore, fileName: originalFileName = '' } = this.props;
        if (
            typeof originalFileName !== 'string' ||
            originalFileName.length === 0
        ) {
            return undefined;
        }
        let fileName = originalFileName;
        // check if extension exists. Handles cases with no extension and files with '.' at the start of the name.
        const ext = fileName.slice(
            (Math.max(0, fileName.lastIndexOf('.')) || Infinity) + 1
        );
        // appened .svg if no extension
        if (!ext) {
            fileName += '.svg';
        }
        const src = dataStore.assetStore.getAssetUrl(fileName);
        return src;
    }

    render() {
        const src = this.iconSrc;
        if (!src) {
            return null;
        }
        return (
            <Image
                src={this.iconSrc}
                onError={this.handleImageError}
                {...this.props}
            />
        );
    }
}

export default withTheme(Icon) as any;



// WEBPACK FOOTER //
// ./src/Components/Icon.tsx